/* RESPONSIBLE TEAM: team-frontend-tech */
export default function (tmap) {
  tmap.transition(
    tmap.hasClass('onboarding__home__liquid-container'),
    tmap.toValue(true),
    tmap.use('toRight', { duration: 700 }),
    tmap.reverse('toLeft', { duration: 700 }),
  );
}
